// app/providers.tsx
'use client'

export function Providers({ children, lang }: { children: React.ReactNode; lang: string }) {
  return <>{children}</>
}
